import { Component, OnInit, ViewChild, ElementRef, NgZone, Input } from '@angular/core';
import { UsuariosService, StorageService, ServicioService } from '../../servicios/index.service';
import { SidebarComponent, MenuComponent, NavbarComponent } from '../shared/index-shared.component';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import { MapsAPILoader, AgmPolyline } from '@agm/core';
import { Router } from '@angular/router';
import {  } from '@types/googlemaps';
import 'rxjs/add/operator/map';


declare var google: any;
declare var drawingManager:any;
declare var jquery:any;
declare var $ :any;
declare var _:any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles:[`
    html,body {
      overflow:hidden;
    }
    `]
})
export class HomeComponent implements OnInit {

  @ViewChild('search') public searchElement: ElementRef;
  @Input() latSidebar:any;
  @Input() lngSidebar:any;
  datosGeolocation: any;
  datosUser:any;
  visibleDatosMenu:boolean;
  btnCerarServ:boolean;
  @Input() idService:any;
  lat: number = 21.9934775;
  lng: number = -99.0176878;
  zoom:number = 5;
  mapTypeControl:boolean = true;
  modal:boolean = false;
  usuarios:any;
  marker_user:boolean;
  marca_ini:boolean;
  marca_fin:boolean;
  btnsSearch:boolean;
  searchValue:boolean;
  formService:FormGroup;
  inic_lat:any;
  inic_lng:any;
  fin_lat:any;
  fin_lng:any;
  datosAsignaServ:any;
  markerServSelect:boolean;
  rutaService:boolean = null;
  dirInicioServ:string;
  dirFinServ:string;
  //Datos user
  nomUser:string;
  apellidoUser:string;
  telUser:any;
  emailUser:any;
  userServ:any;
  pp_dir:any;
  pll_dir:any;
  btnCancelar: boolean = false;
  caract:any;
  empresa:any;
  btnCancelarServAsig:boolean = false;
  opacidad:number;
  @Input() is_open:boolean = false;
  latCircle:number = 25.6707017;
  lngCircle:number = -100.45652690000001;
  radius:number =100;
  formCordenadas:any;
  btnBuscarCoord:boolean =  true;
  btnCancelarCoord:boolean = false;
  aceptaPuntoCoord:boolean = false;
  headCoordText:string = "inicial";
  btnBuscarCoordFin:boolean = false;
  linea_ruta:boolean = false;
  datos_linea_ruta:any;
  polilinea:any;
  seguimiento_subs:any;
  ventana:any;
  subs_ventana:any;
  datos_subs_ventana:any;
  subs_ventana_user:any;
  datos_subs_ventana_user:any;
  ubic_icon:any;
  snaptoroad_line:any;
  select_t_unidad:any;
  select_t_carga:any;
  t_unidad_form:any;
  scaleControl:boolean = true;
  usePanning:boolean = true;
  prox:any;
  coords_prox:any = [];
  datosCoords:any = [];
  distancia_bus:any;
  type_autocomplete:string = "address";
  datos_ususario:any;
  registro_subs:any;
  data_registro:any;
  datos_polilinea_hist_mostrar:boolean = false;
  datos_polilinea_hist:any=[];
  datos_poli_impar:any="";
  btnModalBuscar:boolean = false;
  datos_serv_modal:any;
  datos_user_distance:any;
  datos_coord_filter:any;
  datos_serv:any = [];
  time_modal:any;
  t_carga_form:any;
  msj_err_umc:boolean = false;
  datos_ejemplo:any = [];
  ejemplo_val:boolean = false;

  constructor(private _us:UsuariosService, private storage:StorageService, public router:Router,
              public ngZone:NgZone, private mapsAPILoader:MapsAPILoader, private _ss:ServicioService) {

    this.navegador();
    this.form_service();
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';
    this.roles_sesion();
    this.asigna_serv();
    this.form_cordenadas();
  }
  mouseMove(event){
    console.log("circulo",event);
  }

  ngOnInit() {

    this.storage_btn_cancelar();
    let rol = this.storage.consult_storage("rol");
    if( rol !== "2"  ){
      this.buscador();
    }

    this.datos_ususario = this._us.usuarios.map(res=>res).subscribe(data=>{
      console.log(data);
      this.usuarios = data;
      if(this.ventana == false){
        this.subs_ventana.unsubscribe();
        this.subs_ventana_user.unsubscribe();
        console.log("se cumple en soket principal");
      }
    });

    this.btn_termina_p();
    $(document).ready(function() {
      let ventana_ancho = $(window).width();
      let ventana_alto = $(window).height();
      $("#map").css({"width":ventana_ancho, "height": ventana_alto - 35});
      $("body").css("overflow","hidden");
      $("#buscar").attr("placeholder","Buscar dirección inicial");
    });
    this.marcas();

  }

  usuarios_asignados(){
    /*
    this.datos_ususario = this._us.ubicacion_users("").subscribe(data=>{

    });
    */
  }

  ngOnDestroy(){
    if( this.datos_ususario ){
      this.datos_ususario.unsubscribe();
    }

  }

  marcas(){
    let marca = this.storage.consult_storage("marcas");
    if( marca == "true" ){
      this.is_open = true;
    }else{
      this.is_open = false;
    }
  }

  form_cordenadas(){
    this.formCordenadas = new FormGroup({
      'inp_lat': new FormControl('',[Validators.required]),
      'inp_lng': new FormControl('',[Validators.required])
    });
  }

  form_service(){
    let user = this.storage.consult_storage('pp');
    let time = new Date().getTime();
    this.formService = new FormGroup({
      'nom_empresa':new FormControl('', [ Validators.required, Validators.minLength(3)] ),
      'nom_resp':new FormControl('', [ Validators.required, Validators.minLength(5)] ),
      'ref': new FormControl(''),
      'num_tel':new FormControl('', [ Validators.required, Validators.pattern("[0-9]{10}")]),
      'status':new FormControl('0'),
      'timestamp': new FormControl(time),
      'carac': new FormControl('', [Validators.required, Validators.minLength(8)]),
      't_unidad_selec': new FormControl(''),
      't_unidad': new FormControl(''),
      'v_especializado': new FormControl(''),
      'remolque': new FormControl(''),
      'remolque_ref': new FormControl(''),
      'accesorios': new FormControl(''),
      't_carga': new FormControl(''),
      't_carga_esp': new FormControl(''),
      'precio': new FormControl('', [Validators.required, Validators.pattern('[0-9]{1,8}')])
    });

  }

  guardar_service(){
    let datos = this.formService.value;
    console.log("Datos de formulario", datos);
    this.coord_st();
    let usuario = this.storage.consult_storage('user');
    let time = new Date().valueOf().toString();

    if( datos.t_unidad_selec !== "" && datos.t_unidad_selec !== "1" ){
      if(datos.t_unidad_selec == undefined){
        this.t_unidad_form = null;
      }else{
        this.t_unidad_form = datos.t_unidad_selec;
      }
    }else if( datos.t_unidad !== "" ){
      this.t_unidad_form = datos.t_unidad;
    }else{
      this.t_unidad_form = null;
    }

    if( datos.t_carga !== "" && datos.t_carga !== "1" ){
      if(datos.t_carga == undefined){
        this.t_carga_form = null;
      }else{
        this.t_carga_form = datos.t_carga;
      }
    }else if( datos.t_carga_esp !== "" ){
      this.t_carga_form = datos.t_carga_esp;
    }

    console.log(this.t_unidad_form);

    let nvo_serv = { 'nom_empresa':datos.nom_empresa, 'inic_lat': this.number(this.inic_lat),
                     'inic_lng': this.number(this.inic_lng), 'resp':datos.resp, 'tel': datos.num_tel,
                     'status':0, 'ref': datos.ref, 'fin_lat': this.number(this.fin_lat),
                     'fin_lng': this.number(this.fin_lng), 'realizado': usuario, "timestamp":time,
                     'nom_resp':datos.nom_resp, 'inic_dir':this.pp_dir, 'fin_dir':this.pll_dir,
                     "caract":datos.carac, 't_unidad': this.t_unidad_form, "t_carga":this.t_carga_form,
                     'v_especializado':datos.v_especializado, "remolque":datos.remolque, "remolque_ref":datos.remolque_ref,
                     'accesorios':datos.accesorios, 'precio':datos.precio
                   };

    this._ss.nuevoServicio(nvo_serv).subscribe(data=>{
      console.log(nvo_serv);
      if( data.name !== null ){
        $("#buscar").removeClass('hidden');
        $("#service-modal").modal('toggle');
        $('#form-serv').trigger("reset");
        this.modal = false;
        this.btnBuscarCoord = true;
        this.btnCancelarCoord = false;
        $.notify({
          icon: 'fa fa-dot-circle-o',
          title:"<b>Servicio agregado</b><br>",
          message:"El servicio se agrego correcamente Id:" + data.name,
          url: ""
        });
        this.storage.elimina_st('pp');
        this.storage.elimina_st('pll');
        this.storage.elimina_st('pp_dir');
        this.storage.elimina_st('pll_dir');
      }
    }),
    error=> console.log(error);

  }

  storage_btn_cancelar(){
    let event = this.storage.consult_storage("event_selec");
    if(event){
      this.storage.elimina_st("event_selec");
    }
  }
  coord_st(){
    //Separamos las coordenandas guardadas en storage
    let pp = this.storage.consult_storage("pp");
    let pll = this.storage.consult_storage("pll");
    let pp_dir = this.storage.consult_storage("pp_dir");
    let pll_dir = this.storage.consult_storage("pll_dir");

    if( pp !== null && pll !== null ){
        let inicio = pp.split(",");
        let fin = pll.split(",");
        this.inic_lat = inicio[0];
        this.inic_lng = inicio[1];
        this.fin_lat  = fin[0];
        this.fin_lng  = fin[1];
        this.pp_dir   = pp_dir;
        this.pll_dir  = pll_dir;
    }
  }

  private number(value: any): number {
    return +value;
  }

  navegador(){
    let user = this.storage.user_consult();
    if( !user ){
      return this.router.navigate(['login']);
    }
  }

  cambio_centro(evento){
    console.log(evento);
    this.lat = evento.latitude;
    this.lng = evento.longitude;
  }

  buscador(){

    this.mapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement, { types:[this.type_autocomplete] });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
              let place: google.maps.places.PlaceResult = autocomplete.getPlace();
              if(place.geometry === undefined || place.geometry === null ){
                return;
              }
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
            this.zoom = 16;
            //Punto de partida
            let pp = this.storage.consult_storage("pp");
            if( pp !== null ){
              this.btnBuscarCoord = false;
              this.marca_fin = true;
              this.storage.guarda_st("pll",this.lat + "," + this.lng);
              this._ss.geocode(this.lat + "," +this.lng).subscribe(datacode=>{
                this.storage.guarda_st("pll_dir",datacode.results[0].formatted_address);
              });
            }else{
              this.btnBuscarCoord = false;
              this.marca_ini = true;
              this.btnsSearch = true;
              this.storage.guarda_st("pp",this.lat + "," + this.lng);
              this._ss.geocode(this.lat + "," +this.lng).subscribe(datacode=>{
                this.storage.guarda_st("pp_dir",datacode.results[0].formatted_address);
              });
            }
          });
        });
      }
    );
  }
  dragEndMarcador(evento){
    this.storage.elimina_st("pp");
    this.storage.guarda_st("pp",evento.coords.lat+","+evento.coords.lng);
    this._ss.geocode(evento.coords.lat + "," +evento.coords.lng).subscribe(datacode=>{
      this.storage.guarda_st("pp_dir",datacode.results[0].formatted_address);
    });
  }

  dragEndMarcadorFin(evento){
    this.storage.elimina_st("pll");
    this.storage.guarda_st("pll",evento.coords.lat+","+evento.coords.lng);
    this._ss.geocode(evento.coords.lat + "," +evento.coords.lng).subscribe(datacode=>{
      this.storage.guarda_st("pll_dir",datacode.results[0].formatted_address);
    });
  }

  aceptarPunto(){

    let pp  = this.storage.consult_storage("pp");
    let pll = this.storage.consult_storage("pll");
    if( pp !== null && pll == null ){
      this.marca_ini = false;
      this.zoom = 5;
      $('#inp-busqueda').val('');
      $.notify({
        title:"<b>Buscar destino:</b><br>",
        message:"Busca un destino para la unidad"
      },{
      	type: 'warning'
      });
    }

    if(  pp !== null  && pll !== null ){
      this.coord_st();
      this.marca_ini = false;
      this.marca_fin = false;
      this.btnsSearch = false;
      this.zoom = 5;
      $("#service-modal").modal();
      $("#buscar").val("");
      $("#buscar").attr("disabled", true);
      this.modal = true;
    }else{
      $("#buscar").val("");
      $("#buscar").attr("placeholder", "Buscar dirección final");
    }

  }
  termina_proceso(){
    this.coord_st();
    $("#service-modal").modal();
  }

  btn_termina_p(){
    let pp  = this.storage.consult_storage("pp");
    let pll = this.storage.consult_storage("pll");
    if( pp !== null && pll !== null ){
      this.modal = true;
    }
  }

  cancelarPunto(){
    this.btnCancelarCoord = false;
    this.searchValue = true;
    this.modal = false;
    this.marca_ini = false;
    this.btnsSearch = false;
    this.zoom = 5;
    this.modal = false;
    $("#inp_lat").val('');
    $('#inp_lng').val('');
    $("#buscar").removeClass('hidden');
    $('#buscar').val('');
    $('#buscar').attr("disabled",false);
    $("#buscar").attr("placeholder", "Buscar dirección inicial");
    this.btnBuscarCoord = true;
    this.storage.elimina_st("pp");
    this.storage.elimina_st("pll");
    this.storage.elimina_st("pp_dir");
    this.storage.elimina_st("pll_dir");
    $.notify({
    	message: 'El servicio fue cancelado.'
    },{
    	type: 'danger'
    });
  }

  roles_sesion(){
    let rol = this.storage.consult_storage('rol');
    if( rol == '1' ){
      this.marker_user = false;
      this.searchValue = true;
      this.btnBuscarCoord = true;
    }
    if( rol == '2' ){
      this.marker_user = true;
      this.searchValue = false;
      this.btnBuscarCoord = false;
    }
    if( rol == 'account-adm' || rol == 'account-espe' ){
      this.btnBuscarCoord = false;
      this.marker_user = true;
      this.searchValue = false;
    }
  }

  mouseOver(evento){
    this.subs_ventana = this._us.datos_panel(evento).subscribe(data=>{
      this.datos_subs_ventana = data;
    });
    this.subs_ventana_user = this._us.valida_datos(evento).subscribe(data=>{
      this.datos_subs_ventana_user = data;
    });
    this.ventana = true;
  }

  mouseOut(evento){

    this.ventana = false;
    setTimeout(()=>{
      this.subs_ventana.unsubscribe();
      this.subs_ventana_user.unsubscribe();
    },1000)
  }

  markerClick(key:any, isOpen:boolean){

    console.log(key);
    if(isOpen){
      this._us.marca_is_open(key.$key, false);
      //this.seguimiento_subs.unsubscribe();
    }else{
      //this._us.marca_is_open(key.$key, true);
      this.ver_ruta_user(key.servicio, key);
      let st_panel = this.storage.consult_storage("user_panel");

      if(st_panel !== key.$key){
        this.storage.guarda_st("user_panel",key.$key);
        //this.seguimiento_subs.unsubscribe();
        this.seguimiento_subs = this._us.datos_panel(key.$key).subscribe(data=>{
          this.datosGeolocation = data;
        });

      }else{

        this.seguimiento_subs = this._us.datos_panel(key.$key).subscribe(data=>{
          this.datosGeolocation = data;
        });

      }

    }
    $(".sidebar").removeClass("hidden");
    this._us.valida_datos(key.$key).subscribe(data=>{
      this.datosUser = data;
    });
    this.visibleDatosMenu = true;
    let st = this.storage.consult_storage("event_selec");
    if(st){
      this.btnCerarServ = true;
    }else{
      this.btnCerarServ = false;
    }
    $("body").removeClass("sidebar-collapse");
  }

  ver_ruta_user( servicio:any, key_user:any ){
    if( servicio !== 0 ){
      let key_coord = key_user;
      this.linea_ruta = true;
      this._us.consulta_service_id(servicio).subscribe(data=>{
        this.datos_linea_ruta = data;
        let actual  = key_coord.lat+","+key_coord.lng;
        let inicial = this.datos_linea_ruta.inic_lat+","+this.datos_linea_ruta.inic_lng;
        this._ss.directions(actual,inicial).subscribe(data_coord=>{
          this.polilinea = data_coord.routes[0].legs[0].steps;
          this.ubic_icon = this.polilinea.pop();
        });
        this.snaptoroad_line ="";
        for( let item of this.polilinea){
          this.snaptoroad_line += item.start_location.lat+","+item.start_location.lng+"|"+item.end_location.lat+","+item.end_location.lng+"|";
        }
        let startUbicFin = this.ubic_icon.start_location.lat+","+this.ubic_icon.start_location.lng;
        let endUbicFin = this.ubic_icon.end_location.lat+","+this.ubic_icon.end_location.lng;
        this._ss.snapToRoad(this.snaptoroad_line+startUbicFin+"|"+endUbicFin).subscribe(data=>{
          this.snaptoroad_line = data;
          console.log(this.snaptoroad_line);
        });
      });
    }else{
      console.log("Sin servicio");
      this.linea_ruta = false;
    }
  }

  asigna_serv(){
    let st = this.storage.consult_storage("rol");

    if( st == "2" ){
      this._us.consulta_servicios(st).subscribe(data=>{
        this.datosAsignaServ = data;
      });
      //this.datosAsignaServ =
    }

  }
  idService_map(event){

    $("#unidades-cercanas").modal('toggle');
    this.buscarProximidad(event.lat,event.lng, event.key);
    this.btnCancelar = true;
    this.btnModalBuscar = true;
    this.zoom = 14;
    this.markerServSelect = true;
    this.lat = this.number(event.lat);
    this.lng = this.number(event.lng);
    this.storage.guarda_st('event_selec',event.key);
    /*
    this._ss.getServicio(event.key).subscribe(data=>{
      this.datos_serv_modal = data;
    });
    */
    $.notify({
      title:"<b>Buscar unidad cercana:</b><br>",
      message:"Selecciona una unidad cercana para asignarle el servicio"
    },{
      type: 'warning'
    });
    this.visibleDatosMenu = false;

  }

  mostrar_modal(){
    $("#unidades-cercanas").modal('toggle');
  }

  ubic_sidebar(evento:any){
    this.zoom = 16;
    this.lat = this.number(evento.user.lat);
    this.lng = this.number(evento.user.lng);
    this.markerServSelect = false;
    this.storage.elimina_st('event_selec');
  }

  btn_cancelar(event){
    $("#buscar").attr("disabled", false);
    this.btnCancelar = event.botonCancelar;
    this.markerServSelect = false;
    this.zoom = 9;
  }

  coord_serv_menu(evento){
    let st = this.storage.consult_storage('event_selec');
    this._us.consulta_service_id( st ).map(res=>res).subscribe(data=>{
      this.dirInicioServ = data.inic_dir;
      this.dirFinServ    = data.fin_dir;
      this.caract        = data.caract;
      this.empresa       = data.nom_empresa;
    });
    this._us.valida_datos(evento.user).map(res=>res).subscribe(data=>{
      this.apellidoUser = data.apellidos;
      this.nomUser      = data.nombre;
      this.emailUser    = data.email;
      this.telUser      = data.tel;
      this.userServ     = data.$key;
    });
  }

  asigna_serv_user( user:any ){
    let st = this.storage.consult_storage('event_selec');

    this._ss.actualizaServicio(user,st).subscribe(data=>{
      if( data.status !== null ){
        $("#serv-disp").modal('toggle');
        //this.btnCancelarServAsig = true;
        $.notify({
          icon: 'fa fa-dot-circle-o',
          title:"<b>Servicio asignado</b><br>",
          message:"El servicio se le asigno al usuario:" + user,
          url: ""
        });
        console.log(user);
        this._us.seguimiento( user ).subscribe(data=>{
          this.datosGeolocation = data;
        });

      }
    }),
    error=> console.log(error);

  }

  asigna_serv_user_modal( user:any ){
    let st = this.storage.consult_storage('event_selec');
    this.btnCancelar = false;
    this.btnModalBuscar = false;

    this._ss.actualizaServicio(user,st).subscribe(data=>{
      if( data.status !== null ){
        $("#unidades-cercanas").modal('toggle');
        //this.btnCancelarServAsig = true;
        $.notify({
          icon: 'fa fa-dot-circle-o',
          title:"<b>Servicio asignado</b><br>",
          message:"El servicio se le asigno al usuario:" + user,
          url: ""
        });

        this._us.seguimiento( user ).subscribe(data=>{
          this.datosGeolocation = data;
        });

      }
    }),
    error=> console.log(error);
  }

  mostrar_marcas( event ){
    if( event.status_marcas == true ){
      this.is_open = true;
      this.storage.guarda_st("marcas", true);
    }else{
      this.is_open = false;
      this.storage.guarda_st("marcas", false);
    }
  }

  buscarCorrd(){
    $("#coord-inicial").modal('show');
  }

  guardaCorrd(){
    let form = this.formCordenadas.value;
    this.lat = this.number(form.inp_lat);
    this.lng = this.number(form.inp_lng);
    this.zoom = 16;
    let pp = this.storage.consult_storage("pp");
    if( pp !== null ){
      $("#coord-inicial").modal('toggle');
      this.btnBuscarCoordFin = false;
      this.marca_fin = true;
      this.marca_ini = false;
      this.modal = true;
      this.storage.guarda_st("pll",this.lat + "," + this.lng);
      this._ss.geocode(this.lat + "," +this.lng).subscribe(datacode=>{
        this.storage.guarda_st("pll_dir",datacode.results[0].formatted_address);
      });
    }else{
      $("#inp_lat").val('');
      $("#inp_lng").val('');
      $("#coord-inicial").modal('toggle');
      $("#buscar").addClass('hidden');
      this.headCoordText = "final";
      this.btnBuscarCoordFin = true;
      this.btnCancelarCoord = true;
      this.btnBuscarCoord = false;
      this.aceptaPuntoCoord = true;
      this.marca_ini = true;
      this.marca_fin = false;
      this.storage.guarda_st("pp",this.lat + "," + this.lng);
      this._ss.geocode(this.lat + "," +this.lng).subscribe(datacode=>{
        this.storage.guarda_st("pp_dir",datacode.results[0].formatted_address);
      });
    }
  }
  cancela_punto_coord(){
    $("#inp_lat").val('');
    $('#inp_lng').val('');
    $("#buscar").removeClass("hidden");
    this.modal = false;
    this.marca_ini = false;
    this.marca_fin = false;
    this.headCoordText = "inicial";
    this.btnCancelarCoord = false;
    this.btnBuscarCoord = true;
    this.marca_ini = false;
    this.btnBuscarCoordFin = false;
    this.btnsSearch = false;
    this.aceptaPuntoCoord = false;
    this.zoom = 5;
    this.storage.elimina_st("pp");
    this.storage.elimina_st("pll");
    this.storage.elimina_st("pp_dir");
    this.storage.elimina_st("pll_dir");
    $.notify({
    	message: 'El servicio fue cancelado.'
    },{
    	type: 'danger'
    });
  }

  cancela_asig(){
    this.datosCoords = [];
    this.btnCancelar = false;
    this.btnModalBuscar = false;
    this.storage.elimina_st("event_selec");
    this.markerServSelect = false;
    this.zoom = 5;
    $.notify({
    	message: 'La asignación de servicio fue cancelada.'
    },{
    	type: 'danger'
    });
  }

  buscarProximidad(lat:any, lng:any, key:any){

    this._ss.getServicio(key).subscribe(serv=>{
      this.datos_serv = serv;
    });

    this.prox = this._us.usuarios.subscribe(data=>{
      this.coords_prox = data;
      // sacar nodo de el servicio

      for( let item of this.coords_prox ){

        if( item.login == 1 && item.status == 0 && item.servicio == 0 ){

          this.distancia_bus = this._ss.getDistancia(lat+","+lng,item.lat+","+item.lng).subscribe(distancia=>{
            //console.log(distancia);
            let tiempo = new Date().valueOf();
            let restaTime = new Date().valueOf() - this.number(item.timestamp);
            let day = restaTime/86400;
            let hrs = restaTime/3600;
            let min = restaTime/60;
            let sec = restaTime;

            if( sec <= 60 ){
              console.log("hace segundos")
            }else if( min <= 60 ){
              console.log("Hace minutos");
            }

            //console.log(  item.$key,"Dias: "+day, "Hrs: "+hrs, "Min: "+ min, "Sec:" + sec , tiempo);

            this._ss.getUsers(item.$key).subscribe(data=>{
              //console.log("Tipo de unidad", data.unidad.t_unidad);
              this.datosCoords.push({ user:item.$key,t_unidad: data.unidad.t_unidad, v_espe:data.unidad.v_especializado,
                                      remolque: data.unidad.remolque, remolque_ref: data.unidad.remolque_ref,
                                      accesorios: data.unidad.accesorios,t_carga:data.unidad.t_carga,
                                      direccion: distancia.destination_addresses[0], time: item.timestamp,
                                      distancia: distancia.rows[0].elements[0].distance.value,
                                      duracion: distancia.rows[0].elements[0].duration.text
                                      });
                                      //console.log("Tipo de carga",this.datos_serv);
                                      this.datosCoords = _.orderBy(this.datosCoords, 'distancia');
                                      /* Filtro de servicio y unidad */
                                      this.datos_coord_filter = _.filter(this.datosCoords, function(caract){
                                          return caract.t_unidad == "GENERAL";
                                      });
                                      //console.log(this.datos_coord_filter);
            });
          });

          this.msj_err_umc = false;
        }else{
          this.msj_err_umc = true;
        }
      }
      /*
      let filtro = _.orderBy(this.datosCoords, 'distancia');
      console.log("OrderBy",filtro);
      */
    });
    this.prox.unsubscribe();
  }

  historial(evento){

    this.ejemplo_val = false;

    this._ss.consult_user(evento.user).subscribe(data=>{
      this.zoom = 16;
      this.lat = data.lat;
      this.lng = data.lng;
    });

    this._ss.historial(evento.user,evento.fecha_inicial, evento.fecha_final).subscribe(data=>{
      this.data_registro = data;
      console.log(data);
      let cuantos = this.data_registro.length - 1;

      for (let i = 0; i <= cuantos; i++) {
        if( evento.fecha_inicial < this.data_registro[i].timestamp ){
          this.datos_polilinea_hist.push([this.data_registro[i]]);
          console.log(this.data_registro[i]);
        }
      }

      this.ejemplo_val = true;
    });

    /*
    this.registro_subs = this._us.consult_registro(evento.user).subscribe(data=>{
      this.data_registro = data;
      let cuantos = this.data_registro.length - 1;

      for (let i = 0; i <= cuantos; i++) {
        if( evento.fecha_inicial < this.data_registro[i].timestamp ){
          this.datos_polilinea_hist.push([this.data_registro[i]]);
          console.log(this.data_registro[i]);
        }
      }

      this.ejemplo_val = true;

    });
    */

  }

  asignacion_serv(event){
    this.searchValue    = event.btnAsig;
    this.btnBuscarCoord = event.btnAsig;
  }

  consult_asig_event(){
    let st_asig  =  this.storage.consult_storage('btnAsig');
    if( st_asig == "true" ){
      this.searchValue = true;
      this.btnBuscarCoord = true;
    }else{
      this.searchValue = false;
      this.btnBuscarCoord = false;
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/home/home.component.ts